/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Global, css } from "@emotion/react";
import { Flex, Box } from "@theme-ui/components";
import { reset } from "../styles";

import HeaderV2 from "./headerV2";
import Footer from "./footer";
import menuItems from "../data/menu.yml";
import meMenuItems from "../data/me_menu.yml";
import { AnnouncementBanner } from "../components/homepage";
import "react-multi-carousel/lib/styles.css";

const globalStyle = css`
  ${reset}
`;

class Layout2 extends Component {
  render() {
    const region = this.props.region;
    const regionMenuItemsMap = {
      IN: this.props.menuItems??menuItems,
      ME: this.props.meMenuItems??meMenuItems,
      ID: null,
      SG: null,
      MY: null,
    };    
    const headerTop = this.props.announcement ? 52 : 0;

    return (
      <Box sx={{ fontFamily: "body", m: 0 }}>
        <Global styles={globalStyle} />
        <Flex
          sx={{
            flexDirection: "column",
            minHeight: "100vh",
          }}
          as="div"
        >
          {this.props.announcement && (
            <AnnouncementBanner data={this.props.announcement} />
          )}
          {this.props.showHeader ? (
            <HeaderV2
              region={region}
              menuHeaderItems={regionMenuItemsMap}
              headerTop={headerTop}
              showHeaderCTA={this.props.showHeaderCTA}
              demoBlockId={this.props?.demoBlockId}
              isHrGarden={this.props?.isHrGarden}
              isMenuRequired={this.props?.isMenuRequired}
              headerCtaName={this.props?.headerCtaName}
              newFeatureMenuItem={this.props?.newFeatureMenuItem}
              newFeatureMenuItemID={this.props?.newFeatureMenuItemID}
            />
          ) : null}
          <div sx={{ flex: "1 1 auto" }}>{this.props.children}</div>
          {this.props.showFooter ? (
            <Footer
              region={region}
              showStickyFooter={this.props.showStickyFooter}
            />
          ) : null}
        </Flex>
      </Box>
    );
  }
}

Layout2.defaultProps = {
  showFooter: true,
  showHeader: true,
  showStickyFooter: true,
  isMenuRequired: true,
};

Layout2.propTypes = {
  showFooter: PropTypes.bool,
  showHeader: PropTypes.bool,
  showStickyFooter: PropTypes.bool,
  isMenuRequired: PropTypes.bool,
};

export default Layout2;
